import $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/themes/base/datepicker.css';

const body = document.querySelector('body');
const hasHover = window.matchMedia("(hover: hover)").matches;
const mq_sds = "(max-width:1024px)"
const mq_ns = "(max-width:880px)"
const mq_lg = "(max-width:960px)"
const mq_md = "(max-width:850px)"
const mq_sm = "(max-width:560px)"
const IS_TOUCH_DEVICE = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || window.matchMedia('(pointer:coarse)').matches;


/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/
class Modal {
  constructor(obj) {
    this.modalOpenCN = 'is-open';
    this.bodyOpenCN = 'is-modal-open';
    this.modalCN = obj?.modalElm ?? '.js-modal';
    this.openBtnCN = obj?.modalOpenElm ?? '[data-modal-open]';
    this.modalIDattr = 'data-modal-id';
    this.modalCont = document.querySelectorAll(this.modalCN);
    this.closeBtn = document.querySelectorAll('[data-modal-close]');
    this.init();
  }

  init() {
    this.modalCont.forEach(modal => { modal.style.display = 'none'; });
    this.openModal();
    this.closeBtn.forEach(btn => {
      btn.addEventListener('click', (e) => { this.closeModal(); });
    });
  }

  openModal() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest(this.openBtnCN);
      if (!btn) return;
      const modal_id = btn.getAttribute(this.modalIDattr);
      if (!modal_id) return;

      const ids = modal_id.split(',').map(id => id.trim());
      ids.forEach(id => this.openModalById(id));
    });
  }

  openModalById(id) {
    const targetModal = document.querySelector(`${this.modalCN}[${this.modalIDattr}="${id}"]`);
    if (!targetModal) return;

    document.body.classList.add(this.bodyOpenCN);
    targetModal.setAttribute('aria-hidden', 'false');
    targetModal.style.display = 'flex';
    setTimeout(() => targetModal.classList.add(this.modalOpenCN), 100);
  }

  closeModal() {
    this.modalCont.forEach(modal => {
      if (!modal.classList.contains(this.modalOpenCN)) return;

      modal.classList.remove(this.modalOpenCN);
      modal.setAttribute('aria-hidden', 'true');

      setTimeout(() => {
        modal.style.display = 'none';

        // bodyのクラスはまだ開いているモーダルがあれば残す
        const anyOpen = Array.from(this.modalCont).some(m => m.classList.contains(this.modalOpenCN));
        if (!anyOpen) document.body.classList.remove(this.bodyOpenCN);
      }, 500);
    });
  }
}


/*---------------------------------------------------------------------------------
  debounce
---------------------------------------------------------------------------------*/


const _debounce = (func, delay) => {
  let timer = 0;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(null, args), delay);
  }
}


const _throttle = (func, timeout) => {
  let timer;
  let lastTime;  //前回実行された時のタイムスタンプ（最初は undefined）
  return function (...args) {
    const context = this;
    if (!lastTime) {
      // 初回のみ
      func.apply(context, args);
      lastTime = Date.now();
    } else {
      // 初回以外
      clearTimeout(timer);
      timer = setTimeout( () => {
        func.apply(context, args);
        lastTime = Date.now();
      }, timeout - (Date.now() - lastTime) );
    }
  }
}


/*---------------------------------------------------------------------------------
  page loader
---------------------------------------------------------------------------------*/

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

async function pageLoadingScreen() {
  const loader = document.querySelector('.page-transition');
  await sleep(500)
  loader.classList.add('is-loaded');
  await sleep(600)
  loader.style.display = 'none';
}

window.onload = async () => {
  await pageLoadingScreen();
  scrollAnime();
};


/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/


const scrollAnime = () => {
  const elems = document.querySelectorAll('.js-fadein');
  if (!elems.length) return;

  elems.forEach(elem => {
    const elRmg = elem.dataset.rmgn || '-20% 0px';
    const options = {
      root: null,
      rootMargin: `${elRmg}`,
      threshold: parseFloat(elem.dataset.threshold) || 0,
    };

    let observer;

    if(elem.hasAttribute('data-stagger')) {
      observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          const stagger = elem.dataset.stagger || 300;
          const items =  elem.querySelectorAll('.js-fadein-stagger');
          if (entry.isIntersecting) {
            items.forEach((item, index) => {
              setTimeout(() => {
                item.classList.add('is-show');
              }, index * stagger);
            });
            observer.unobserve(entry.target);
          }
        });
      }, options);
    } else {
      observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-show');
            observer.unobserve(entry.target);
          }
        });
      }, options);
    }

    observer.observe(elem);
  });
};




/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/

const landscapeFtg = () => {
  const element = document.querySelector('.fix-cta-group.--landscape');
  if (!element) return;

  const className = '--landscape';
  const mql = window.matchMedia(mq_sds);

  const listener = (event) => {
    if (event.matches) {
      element.classList.remove(className);
    } else {
      element.classList.add(className);
    }
  };

  mql.addEventListener('change', listener);
  listener(mql); // 初回実行
};



/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/

const subNaiHandler = () => {
  const elms = document.querySelectorAll('.js-has-subnavi');
  const mql = window.matchMedia(mq_md);
  let controller = new AbortController();

  const initClass = () => {
    elms.forEach(elm => {
      elm.classList.remove('is-open', 'is-hoverStyle');
    });
  };

  const toggleOpenClass = () => {
    elms.forEach(elm => {
      const btn = elm.querySelector('.js-btn');
      if (!btn) return;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        elm.classList.toggle('is-open');
      }, { signal: controller.signal });
    });
  };

  const handlePCTap = () => {
    elms.forEach(elm => {
      const btn = elm.querySelector('.js-btn');
      if (!btn) return;
      btn.addEventListener('touchstart', (e) => {
        e.preventDefault();
        elm.classList.toggle('is-hoverStyle');
      }, { signal: controller.signal });
    });
  };

  const listener = (event) => {
    controller.abort();
    controller = new AbortController();
    initClass();

    if (event.matches) {
      // SP処理
      toggleOpenClass();
    } else {
      // PC処理
      handlePCTap();
    }
  };

  mql.addEventListener('change', listener);
  listener(mql);
};



/*---------------------------------------------------------------------------------
  Mobile gavi
---------------------------------------------------------------------------------*/

const mobileGnavi = () => {
  const mql = window.matchMedia(mq_ns);
  const menuBtn = document.querySelector('.js-menu-btn');
  const navi = document.querySelector('.gnavi');
  const openClass = 'is-gnavi-open';
  let activeAction = true;

  const handleClick = (event) => {
    event.preventDefault();
    if (activeAction) {
      body.classList.toggle(openClass);
      if (body.classList.contains(openClass)) {
        naviOpen();
      } else {
        naviClose();
      }
    }
  };

  const naviOpen = () => {
    activeAction = false;
    menuBtn.classList.add('is-show');
    body.classList.add('is-no-scroll');
    navi.style.display = 'block';
    // document.querySelector('meta[name="theme-color"]').setAttribute('content', '#FFFFFF');
    setTimeout(function () {
      navi.classList.add('is-open');
      activeAction = true;
    }, 100);
  }

  const naviClose = () => {
    activeAction = false;
    menuBtn.classList.remove('is-show');
    body.classList.remove('is-no-scroll');
    navi.classList.remove('is-open');
    setTimeout(function () {
      navi.style.display = 'none';
      activeAction = true;
    }, 600);
  }

  const listener = (event) => {
    if (event.matches) {
      // SP用処理
      navi.style.display = 'none';
      menuBtn.removeEventListener('click', handleClick);
      menuBtn.addEventListener('click', handleClick);
    } else {
      // PC用ブレークポイント用処理
      navi.style.display = '';
      body.classList.remove('is-no-scroll','is-gnavi-open');
      menuBtn.classList.remove('is-show');
      activeAction = true;
      menuBtn.removeEventListener('click', handleClick);
    }
  };

  mql.addEventListener('change', listener);
  listener(mql);
}



/*---------------------------------------------------------------------------------
  Accordion Box
---------------------------------------------------------------------------------*/

const accordionBox = () => {
  const accordions = document.querySelectorAll('.js-accordion');
  if (!accordions.length) return;

  accordions.forEach(pd => {
    const btn = pd.querySelector('[data-acc-trigger]');
    const box = pd.querySelector('[data-acc-body]');
    let activeAction = true;
    btn.addEventListener('click', (e) => {
      pd.classList.toggle('is-open');
    });
  });
}

/*---------------------------------------------------------------------------------
  Switch Tab
---------------------------------------------------------------------------------*/

const switchTab = () => {
  const tabButtons = document.querySelectorAll('.js-tab-btn');
  const tabPanels = document.querySelectorAll('.js-tab-panel');
  const tabCurrentClass = 'is-tab-current';

  tabPanels.forEach((panel) => {
    // let h = panel.offsetHeight;
    // panel.style.setProperty('--panel-h', h + 'px');
    panel.style.display = 'none';
  });

  tabButtons.forEach((button) => {
    button.addEventListener('click', function (e) {
      const parent = button.parentElement;
      const tabGroup = button.getAttribute('data-tab-group');
      const tabButton = parent.querySelectorAll(`.js-tab-btn[data-tab-group="${tabGroup}"]`);
      const indexTabID = button.getAttribute('data-tab-id');
      const panelGroup = document.querySelectorAll(`.js-tab-panel[data-tab-group="${tabGroup}"]`);

      tabButton.forEach((btn) => {
        btn.classList.remove(tabCurrentClass);
      });

      button.classList.add(tabCurrentClass);

      panelGroup.forEach((panel) => {
        panel.style.display = 'none';
        panel.classList.remove(tabCurrentClass,'is-fade');
      });

      const selectedPanel = document.querySelector(`.js-tab-panel[data-tab-group="${tabGroup}"][data-tab-id="${indexTabID}"]`);

      if (selectedPanel) {
        selectedPanel.style.display = 'block';
        selectedPanel.classList.add(tabCurrentClass);
        setTimeout(function () {
          selectedPanel.classList.add('is-fade');
        }, 100);
      }
    });
  });
};

/*---------------------------------------------------------------------------------
  selectbox placeholder
---------------------------------------------------------------------------------*/

const selectBoxPlaceholder = () => {
  const selectBoxes = document.querySelectorAll('select');
  if (!selectBoxes.length) return;

  selectBoxes.forEach((select) => {
    select.addEventListener("change", function () {
      this.classList.add('is-selected');
      let placeholder = this.querySelector('._placeholder');
      if (placeholder) {
        let span = document.createElement('span');
        span.classList.add('selector-placeholder-hide');
        placeholder.parentNode.insertBefore(span, placeholder);
        span.appendChild(placeholder);
      }
    });
  });
}


/*---------------------------------------------------------------------------------
  TOP PAGE hero slide
---------------------------------------------------------------------------------*/

const topHeroSlide = () => {
  const slide = document.getElementById('js-heroSlide');
  if (!slide) return;

  const splide = new Splide(slide , {
    arrows: false,
    autoplay: true,
    interval: 5000,
    speed: 1000,
    updateOnMove: true,
    type: 'loop',
    perPage: 1,
    pagination: false,
    drag: false,
    breakpoints: {
      460: {
        pagination: true,
        classes: {
          pagination: 'slide-pagination',
          page : 'slide-pagination__page',
        },
      },
    }
  });

  splide.on('pagination:mounted',function(data){
    data.items.forEach(function(item) {
      let num = item.page + 1;
      item.button.textContent = String(num).padStart(2, '0');
    });
  });

  splide.mount();
}

/*---------------------------------------------------------------------------------
  TOP PAGE MV height
---------------------------------------------------------------------------------*/

const updateMvHeight = (callback) => {
  const inner = document.querySelector('.top-mv__inner');
  const container = document.querySelector('.top-mv');
  
  if (inner && container) {
    container.style.height = `${inner.offsetHeight}px`;
  }

  if (typeof callback === 'function') {
    callback(); // 高さ設定後にcallback実行
  }
};

/*---------------------------------------------------------------------------------
  TOP PAGE thought images
---------------------------------------------------------------------------------*/

const topThoImages = () => {
  const thImgs = document.querySelector('.top-thought__imgs');
  if (!thImgs) return;
  const source = thImgs.querySelector('.thi-source');
  if (!source) return;
  const images = thImgs.querySelectorAll('.thi-item');
  // 要素を配列に変換してシャッフル（ランダム順）
  const shuffled = Array.from(images).sort(() => Math.random() - 0.5);
  const mql = window.matchMedia(mq_ns);
  let newElm = null;

  const randomAddClass = () => {
    shuffled.forEach((el, index) => {
      // ランダムな遅延時間（例：0〜1000ms）+ 少しずつ増加
      // const delay = Math.random() * 1000 + index * 100;
      const delayInterval = 200;
      setTimeout(() => {
        el.classList.add('is-show'); // 任意のクラスに変更
      }, delayInterval * index);
    });
  }

  const options = {
    root: null,
    rootMargin: '-20% 0px',
    threshold: 0,
  };

  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      randomAddClass();
      observer.unobserve(entries[0].target); // 一度だけ実行
    }
  }, options);

  const listener = (event) => {
    if (event.matches) {
      // SP用処理
      if (!newElm) {
        for (let i = 0; i < 2; i++) {
          newElm = source.cloneNode(true);
          source.insertAdjacentElement('afterend', newElm);
        }
      }
      document.querySelectorAll('.thi-item.is-show').forEach(image => {
        image.classList.remove('is-show');
      });
    } else {
      // PC用処理
      if (newElm) {
        newElm.remove();
        newElm = null;
      }

      // 高さの設定後に observer を動かす
      updateMvHeight(() => {
        observer.observe(thImgs);
      });
    }
  };

  mql.addEventListener('change', listener);
  listener(mql);
};


/*---------------------------------------------------------------------------------
  幅固定のスライダー
---------------------------------------------------------------------------------*/

const fixWidthSlide = () => {
  const slides = document.querySelectorAll('.js-fw-slide');
  if (!slides.length) return;

  slides.forEach(function(slide) {
    const itemWidth = slide.getAttribute('data-item-width') || '340px';
    const bp = Number(itemWidth.replace('px', '') * 1.7);
    let arrows;
    if(slide.querySelector('.fw-slide__mo_arrows')) {
      arrows = `,"arrows":"true"`;
    } else {
      arrows = ``;
    }

    const moOption = `{"breakpoints":{"${bp}":{"fixedWidth":false,"perPage":1,"focus":"center","gap":"10px"${arrows}}}}`;

    let autoPlayVal = true;
    let intervalVal = 4000;
    let speedVal = 500;
    let rewindVal = true;

    if(slide.dataset.autoplay === 'false') {
      autoPlayVal = false;
      rewindVal = false;
    }

    if(slide.dataset.iv) {
      intervalVal = slide.dataset.iv;
    }

    if(slide.dataset.speed) {
      speedVal = slide.dataset.speed;
    }


    slide.setAttribute('data-splide', moOption);
    const mql = window.matchMedia(`(max-width:${bp}px)`);

    const splide = new Splide( slide, {
      arrows: false,
      autoplay: autoPlayVal,
      interval: intervalVal,
      speed: speedVal,
      rewind: rewindVal,
      updateOnMove: true,
      fixedWidth: itemWidth,
      gap: '30px',
      pagination: false,
      padding: false
    });
    splide.mount();

    const listener = (event) => {
      if (event.matches) {
        // SP処理
        slide.classList.add('is-fw-width');
      } else {
        // PC処理
        slide.classList.remove('is-fw-width');
      }
    };

    mql.addEventListener('change', listener);
    listener(mql);
  });
}

/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/

const loopTicker = () => {
  const tickers = document.querySelectorAll('.js-loopTicker');
  if (!tickers.length) return;

  const isTopPage = window.location.pathname === '/';

  tickers.forEach((ticker) => {
    const sourceItems = Array.from(ticker.querySelectorAll('[data-ticker-source]'));
    let itemCount = sourceItems.length;

    if (isTopPage) {
      if (itemCount < 4) {
        let totalCount = itemCount;
        while (totalCount < 4) {
          for (let i = 0; i < itemCount; i++) {
            const cloneSource = sourceItems[i];
            const newElement = cloneSource.cloneNode(true);
            newElement.setAttribute('aria-hidden', 'true');
            sourceItems[itemCount - 1].insertAdjacentElement('afterend', newElement);
            totalCount++;
            if (totalCount >= 4) break;
          }
        }
        itemCount = totalCount;
      }
    }

    if(ticker.hasAttribute('data-ticker-duration')) {
      const dir = ticker.getAttribute('data-ticker-duration');
      ticker.style.setProperty('--_duration', `${dir}`);
    }
    if(ticker.hasAttribute('data-ticker-loops')) {
      const loops = parseFloat(ticker.getAttribute('data-ticker-loops')) - 1;
      ticker.style.setProperty('--_ticker-length', loops);
      for (let i = 0; i < loops; i++) {
        const newElement = sourceItems[0].cloneNode(true);
        newElement.setAttribute('aria-hidden', 'true');
        sourceItems[0].insertAdjacentElement('afterend', newElement);
      }
    } else {
      ticker.style.setProperty('--_ticker-length', '2');
      const newElement = sourceItems[0].cloneNode(true);
      newElement.setAttribute('aria-hidden', 'true');
      sourceItems[0].insertAdjacentElement('afterend', newElement);
    }

    const track = ticker.querySelector('[data-ticker-track]');
    if (track) {
      const startAnimation = () => {
        track.style.animation = 'none';
        track.offsetHeight;
        track.style.animation = null;
        
        setTimeout(() => {
          track.style.animationPlayState = 'running';
        }, 100);
      };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            startAnimation();
          } else {
            track.style.animationPlayState = 'paused';
          }
        });
      }, {
        threshold: 0.1
      });
      
      observer.observe(ticker);

      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
          startAnimation();
        }
      });

      window.addEventListener('focus', startAnimation);

      window.addEventListener('scroll', () => {
        track.style.animationPlayState = 'running';
      }, { passive: true });

      window.addEventListener('resize', () => {
        track.style.animationPlayState = 'running';
      });
    }

  });
}


/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', function() {
    const upperSlider = document.querySelector('.top-voice__ticker .js-loopTicker[data-ticker-dir="LtoR"]');
    const lowerSlider = document.querySelector('.top-voice__ticker .js-loopTicker[data-ticker-dir="RtoL"]');
    
    if (upperSlider && lowerSlider) {
        const upperHeight = upperSlider.offsetHeight;
        const lowerHeight = lowerSlider.offsetHeight;
        const maxHeight = Math.max(upperHeight, lowerHeight);
        
        upperSlider.style.height = maxHeight + 'px';
        lowerSlider.style.height = maxHeight + 'px';
    }
})

/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/

const pageCurrentSection = () => {
  const sections = document.querySelectorAll('.js-psn-section');
  const secNai = document.querySelectorAll('.page-section-navi');
  if (!sections.length) return;

  sections.forEach((el, index) => {
    el.id = `psn-section-${index + 1}`;
  });

  secNai.forEach(navi => {
  const links = navi.querySelectorAll('li a');
  links.forEach((link, index) => {
    link.setAttribute('href', `#psn-section-${index + 1}`);
  });

  //一番最初のリンクに "is-active" クラスを付与
  if (links.length > 0) {
    links[0].classList.add('is-active');
  }
});

  const options = {
    root: null,
    rootMargin: '-50% 0px -50% 0px',
    threshold: 0
  };

  const doWhenIntersect = (entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        activateIndex(entry.target);
      }
    });
  }

  const observer = new IntersectionObserver(doWhenIntersect, options);
  sections.forEach(section => {
    observer.observe(section);
  });

  const activateIndex = (element) => {
    const currentActiveIndex = document.querySelector('.page-section-navi a.is-active');
    if (currentActiveIndex !== null) {
      currentActiveIndex.classList.remove('is-active');
    }
    const newActiveIndex = document.querySelector(`.page-section-navi a[href='#${element.id}']`);
    newActiveIndex.classList.add('is-active');
  }
  
}



/*---------------------------------------------------------------------------------
  youtube埋め込みモーダル
---------------------------------------------------------------------------------*/


const youtubeLazyModal = () => {
  const embedVideos = document.querySelectorAll('.js-modal-video');
  if (!embedVideos.length) return;

  embedVideos.forEach((video) => {
    const iframe = video.querySelector('iframe');
    const videoThumb = video.querySelector('.js-modal-video__thumb');
    const videoBody = video.querySelector('.js-modal-video__body');
    const url = iframe.getAttribute('data-src');
    const thumb = iframe.getAttribute('data-thumb');
    const title = iframe.getAttribute('title');
    const id = url.match(/[\/?=]([a-zA-Z0-9_-]{11})[&\?]?/)[1];
    let thumbCode;

    if (thumb == null || thumb == '') {
      thumbCode = `
      <img src="https://img.youtube.com/vi/${id}/maxresdefault.jpg" alt="${title}" width="1280" height="720" />
      <div class="play-btn"><span class="_icon"></span></div>
      `;
    } else {
      thumbCode = `
      <img src="${thumb}" alt="${title}" width="1280" height="720" />
      <div class="play-btn"><span class="_icon"></span></div>
      `;
    }

    videoThumb.insertAdjacentHTML('afterbegin', thumbCode);
    iframe.remove();

    videoThumb.addEventListener('click', function () {
      if (!videoBody.querySelector('.loded-video')) {
        videoBody.innerHTML = `
        <div class="loded-video">
          <iframe
            src="https://www.youtube.com/embed/${id}?enablejsapi=1"
            title="${title}"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
          </iframe>
        </div>
        `;
      } else {
        return;
      }
    });

    const modalClose = video.querySelectorAll('[data-modal-close]');
    modalClose.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const videoWindow = video.querySelector('.loded-video iframe').contentWindow;
        const iframeController = function(action,arg=null){
          videoWindow.postMessage('{"event":"command", "func":"'+action+'", "args":'+arg+'}', '*');
        };
        iframeController('pauseVideo');
      });
    });
  });
}


/*---------------------------------------------------------------------------------
  ツールチップ
---------------------------------------------------------------------------------*/

const toolTips = () => {
  let group = document.querySelectorAll('.tooltip-group');
  if (!group.length) return;

  const tooltip = () => {
    group = document.querySelectorAll('.tooltip-group');
    let viewportWidth = window.innerWidth;

    group.forEach(gp => {
      const trigger = gp.querySelector('.tooltip-trigger');
      let tooltip = gp.querySelector('.tooltip');
      const ttCloseBtn = gp.querySelector('.tooltip-close');
      let activeAction = true;

      let tooltipRect = tooltip.getBoundingClientRect();
      let left = tooltipRect.left;
      let right = tooltipRect.right;
      const gap = 15;

      tooltip.style = '';
      /* 左端がはみ出した場合 */
      if(left < 0) {
        tooltip.style.setProperty('--_tx', `${left - gap}px`);
      }
      /* 右端がはみ出した場合 */
      if(right > viewportWidth) {
        tooltip.style.setProperty('--_tx', `${right - viewportWidth + gap}px`);
      }

      const ttOpen = () => {
        activeAction = false;
        tooltip.classList.add('is-tap');
        setTimeout(function () {
          activeAction = true;
        }, 100);
      }

      const ttClose = () => {
        activeAction = false;
        tooltip.classList.remove('is-tap');
        setTimeout(function () {
          activeAction = true;
        }, 100);
      }

      ttCloseBtn.addEventListener('touchstart', (event) => {
        ttClose();
      });


      trigger.addEventListener('touchstart', (event) => {
        event.preventDefault();
        if (activeAction) {
          tooltip.classList.toggle('is-tap');
          if (tooltip.classList.contains('is-tap')) {
            ttOpen();
          } else {
            ttClose();
          }
        }
      });
    });
  }

  const debouncedTT = _debounce(tooltip, 300);
  tooltip()

  const mql = window.matchMedia(mq_ns);

  const listener = (event) => {
    if (event.matches) {
      // SP処理
      window.addEventListener('resize', debouncedTT);
    } else {
      document.querySelectorAll('.tooltip').style = '';
    }
  };

  mql.addEventListener('change', listener);
  listener(mql);
}


/*---------------------------------------------------------------------------------
  寺院詳細ページ サイドバースライダー
---------------------------------------------------------------------------------*/

const areaTmpSlide = () => {
  const sliders = document.querySelectorAll('.area-temple-slide');
  if (!sliders.length) return;

  sliders.forEach(function(acSlide) {
    const Track = acSlide.querySelector('.splide__track');
    const List = acSlide.querySelector('.splide__list');

    if (!Track || !List) {
      return;
    }

    const splide = new Splide( acSlide, {
      arrows: false,
      autoplay: false,
      interval: 5000,
      speed: 500,
      gap: '1rem',
      updateOnMove: true,
      pagination: true,
      breakpoints: {
        880: {
          destroy: true,
        },
      },
    });
    splide.mount();
  });
}


/*---------------------------------------------------------------------------------
  寺院詳細ページ　画像スライダー
---------------------------------------------------------------------------------*/

const tmpDtlImageSlide = () => {

  const dtlSlide = document.querySelector('.detail-slide');
  if (!dtlSlide) return;

  let controller = new AbortController();

  const mainSlide = dtlSlide.querySelector('.main-slide');
  const slideNavi = dtlSlide.querySelector('.slide-navi');

  const images =  mainSlide.querySelectorAll('.splide__list img'); // 画像リストを取得
  const container = document.querySelector('.detail-slide .thumbnails'); // wrapするの要素を取得

  const siteFrameMain = document.querySelector('.site-frame-main main');


  //サムネイルリストの作成
  const createThumbList = () => {
    const imagesPerList = 12; // 1つの wrap に入れる画像数
    let wrap;

    images.forEach((img, index) => {
      if (index % imagesPerList === 0) {
        wrap = document.createElement('div');
        wrap.classList.add('splide__slide','wrap');
        container.appendChild(wrap);
      }

      const item = document.createElement('figure');
      item.classList.add('thumbnail');
      item.appendChild(img.cloneNode(true)); // 元の画像を複製して追加
      wrap.appendChild(item);
    });
  }

  const createMobileThumbList = () => {
    images.forEach((img, index) => {
      const item = document.createElement('figure');
      item.classList.add('splide__slide','thumbnail');
      item.appendChild(img.cloneNode(true)); // 元の画像を複製して追加
      container.appendChild(item);
    });
  }

  const delThumbList = () => {
    container.innerHTML = '';
  }

  const thumbClickInterloc = () => {
    const thumbnails = document.querySelectorAll('.slide-navi .thumbnail');
    let current;

    for (var i = 0; i < thumbnails.length; i++ ) {
      initThumbnail( thumbnails[ i ], i );
    }

    function initThumbnail(thumbnail, index) {
      thumbnail.addEventListener('click', function () {
        main.go(index);
      }, { signal: controller.signal });
    }

    main.on('mounted move', function () {
      const thumbnail = thumbnails[main.index];
      if (thumbnail) {
        if (current) {
          current.classList.remove('is-active');
        }
        thumbnail.classList.add('is-active');
        current = thumbnail;
      }
    });
  }

  const main = new Splide( mainSlide, {
    type: 'fade',
    rewind: true,
    pagination: false,
  });

  const slidenavi = new Splide( slideNavi, {
    rewind: true,
    pagination: false,
    gap: '1rem'
  });

  const slidenaviMo = new Splide( slideNavi, {
    type: 'loop',
    rewind: true,
    pagination: false,
    arrows: false,
    isNavigation: true,
    perPage: 3,
    perMove: 1,
    padding: '10%',
    gap: '1rem'
  });


  let lastWidth = siteFrameMain.offsetWidth; // 初期幅を記録
  let lastHeight = siteFrameMain.offsetHeight; // 初期幅を記録
  let isInitialized = false;
  let stdHeight;

  let slideHeight = dtlSlide.offsetHeight;

  const mountFunc = (width) => {
    setTimeout(() => {
      stdHeight = mainSlide.querySelector('img').offsetHeight;
      dtlSlide.style.setProperty('--_msi-h', stdHeight + 'px');
    }, '50');

    if (width <= 900) {
      delThumbList();
      createMobileThumbList();
      main.sync(slidenaviMo);
      main.mount();
      slidenaviMo.mount();
    } else {
      delThumbList();
      createThumbList();
      thumbClickInterloc();
      main.mount();
      slidenavi.mount();
    }
  };

  //初回実行 (ページロード時にも処理を適用)
  mountFunc(lastWidth);

  const resizeHandler = _debounce((width) => {
    mountFunc(width);
  }, 300);

  const resizeObserver = new ResizeObserver(([entry]) => {
    if (!isInitialized) {
      isInitialized = true; // 初回はスキップ
      return;
    }

    const { width, height } = entry.contentRect;

    if (width !== lastWidth) {
      controller.abort();
      controller = new AbortController();
      main.destroy();
      slidenavi.destroy();
      slidenaviMo.destroy();
      resizeHandler(width);
    }

    lastWidth = width;
    lastHeight = height;
    slideHeight = dtlSlide.offsetHeight;
  });

  resizeObserver.observe(siteFrameMain);
}


/*---------------------------------------------------------------------------------
  資料の一括請求ボタン  s-recsInfos
---------------------------------------------------------------------------------*/

const recsInfos = () => {
  const btn = document.querySelector('.js-recsInfos');
  if (!btn) return;

  const checkboxes = document.querySelectorAll('.temple-card input[type="checkbox"]');

  const updateButtonState = () => {
    const anyChecked = Array.from(checkboxes).some(cb => cb.checked);
    btn.disabled = !anyChecked;
  };

  updateButtonState();

  checkboxes.forEach(cb => {
    cb.addEventListener('change', updateButtonState);
  });
}


/*---------------------------------------------------------------------------------
  フォームの個人情報の取扱いに同意 チェックボックス
---------------------------------------------------------------------------------*/

const privacyAgree = () => {
  const privCheck = document.querySelector('#js-priv-check');
  if (!privCheck) return;

  const privSubmit = document.querySelectorAll('.js-priv-submit');

  privCheck.addEventListener('change', function () {
    if (this.checked) {
      privSubmit.forEach(function (element) {
        element.disabled = false;
      });
    } else {
      privSubmit.forEach(function (element) {
        element.disabled = true;
      });
    }
  });
}


/*---------------------------------------------------------------------------------
  table of contents - 記事ページ目次を作成
---------------------------------------------------------------------------------*/

const tableOfContents = () => {
  const toc = document.querySelector('.js-toc');
  if (!toc) return;
  const entryBody = document.querySelector('.entry-body');
  // const heads = entryBody.querySelectorAll('h2, h3');
  const heads = document.querySelectorAll('.entry-body > h2,.entry-body > h3, .entry-body > * > h2, .entry-body > * > h3');

  if (heads && heads.length) {
    let contents = '';
    heads.forEach((head, i) => {
      let className = '';
      switch(head.localName) {
        case "h2":
          className = `hlv-2`;
          break;
        case "h3":
          className = `hlv-3`;
          break;
      }

      // 記事中のヘディングタグに ID を設定
      const headingId = `head${i + 1}`;
      head.id = headingId;

      // 目次リンクの作成
      contents += `<li class="toc-list__item ${className}"><a href="#heading${i + 1}">${head.textContent}</a></li>`;
      head.innerHTML += `<a id="heading${i + 1}"></a>`;
    })
    document.querySelector('.toc-content').innerHTML += `<ol class='toc-list'>${contents}</ol>`;
  }
}


/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/
const condChangeBtn = () => {
  const openBtn = document.querySelector('.cond-chg-btn.js-condChange');
  if (!openBtn) return;

  const panel = document.querySelector('.results-search');
  if (!panel) return;

  const closeBtn = panel.querySelector('.ccb-close');
  if (!closeBtn) return;

  const mql = window.matchMedia(mq_sds);

  const panelOpen = () => panel.classList.add('is-open');
  const panelClose = () => panel.classList.remove('is-open');

  openBtn.addEventListener('click', () => panelOpen());
  closeBtn.addEventListener('click', () => panelClose());

  mql.addEventListener('change', (event) => { if (!event.matches) panelClose(); });
  if (!mql.matches) panelClose();
};

document.addEventListener('DOMContentLoaded', () => {
  const modal = new Modal();
  condChangeBtn();

  // 通常の「お墓を探す」ボタン
  const mainSearchBtns = document.querySelectorAll('.js-condChange:not(.js-gnavi):not(.cond-chg-btn)');
  mainSearchBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      modal.openModalById('area-prefectures');
    });
  });
  
  // グローバルナビ用ボタン（SPのみ）
  const gnaviLis = document.querySelectorAll('.js-gnavi.js-condChange');
  gnaviLis.forEach(gnaviLi => {
    gnaviLi.addEventListener('click', (e) => {
      if (mq_ns.match) {
        e.preventDefault();
        modal.openModalById('area-prefectures');
      }
    }, { capture: true });
  });

  // 条件変更ボタン（都道府県モーダルは開かない）
  const condBtns = document.querySelectorAll('.cond-chg-btn.js-condChange');
  condBtns.forEach(condBtn => {
    condBtn.addEventListener('click', () => {
      const resultsPanel = document.querySelector('.results-search');
      if (resultsPanel) {
        resultsPanel.classList.add('is-open');
      }
    });
  });
});



/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/

const checkboxBind = (rangeSelector, displaySelector, btnSelector) => {
  const range = document.querySelector(rangeSelector);
  const display = document.querySelector(displaySelector);

  if (!range || !display) return;

  const btnSel = btnSelector || '.label-btn';

  const checkboxes = range.querySelectorAll(`${btnSel} input[type="checkbox"]`);

  const applySelections = () => {
    const checkedInputs = Array.from(checkboxes).filter(input => input.checked);

    display.innerHTML = checkedInputs
      .map(input => {
        const labelBtn = input.closest(btnSel);
        const textElement = labelBtn.querySelector('._text');
        return textElement ? `<span>${textElement.textContent.trim()}</span>` : '';
      })
      .join('');

    display.parentNode
      .querySelectorAll('input[type="hidden"]')
      .forEach(el => el.remove());

    const hiddenHTML = checkedInputs
      .map(input => `<input type="hidden" name="${input.name}" value="${input.value}">`)
      .join('');
    display.insertAdjacentHTML('afterend', hiddenHTML);
  };

  const submitBtn = range.querySelector('[data-apply-conditions]');

  if (submitBtn) {
    submitBtn.addEventListener('click', () => {
      applySelections();
      const closeBtn = range.querySelector('[data-modal-close]');
      closeBtn?.click();
    });
  }
};


const radioBind = (rangeSelector, displaySelector, btnSelector) => {
  const range = document.querySelector(rangeSelector);
  const display = document.querySelector(displaySelector);

  if (!range || !display) return;

  const btnSel = btnSelector || '.label-btn';

  const radios = range.querySelectorAll(`${btnSel} input[type="radio"]`);

  const updateDisplay = () => {
    const checkedRadio = Array.from(radios).find(input => input.checked);

    if (checkedRadio) {
      const label = checkedRadio.closest(btnSel);
      const textEl = label?.querySelector('._text');
      display.innerHTML = textEl ? `<span>${textEl.textContent.trim()}</span>` : '';
    } else {
      display.innerHTML = '';
    }
  };

  radios.forEach(rb => rb.addEventListener('change', updateDisplay));
  // updateDisplay();
};


/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/

document.addEventListener("DOMContentLoaded", function(){
  landscapeFtg()
  subNaiHandler()
  mobileGnavi()
  topHeroSlide()
  updateMvHeight()
  window.addEventListener('resize', updateMvHeight);
  topThoImages()
  fixWidthSlide()
  loopTicker()
  pageCurrentSection()
  youtubeLazyModal()
  toolTips()
  areaTmpSlide()
  tmpDtlImageSlide()
  recsInfos()
  privacyAgree()
  tableOfContents()
  condChangeBtn()
  const modals = new Modal()
  selectBoxPlaceholder()
  accordionBox()
  switchTab()

  radioBind('.area-pref-modal','.area-pref-value','.pref-btn')
  checkboxBind('.area-muni-modal','.area-muni-value','.condition-item')
  checkboxBind('.conditions-modal','.conditions-value','.condition-item')
})


$(function () {
  /**
   * 同意ボタンの非活性化
   */
  const disabledCheckElement = $('[data-submit-disabled-check-trigger]')
  const disabledSubmitElement = $('[data-submit-disabled]')
  if (disabledCheckElement.length && disabledSubmitElement.length) {
    disabledCheckElement.on('change', function () {
      if ($(this).prop('checked')) {
        disabledSubmitElement.attr('data-submit-disabled', '')
        disabledSubmitElement.find('input, button').prop('disabled', false)
      } else {
        disabledSubmitElement.attr('data-submit-disabled', 'disabled')
        disabledSubmitElement.find('input, button').prop('disabled', true)
      }
    })
  }


  /**
   * Cookieからutmパラメータを取得し、フォーム値に反映する
   */
  const utmParams = {
    utm_campaign: null,
    utm_source: null,
    utm_medium: null,
    utm_content: null,
    utm_term: null
  }
  const cookieLists = document.cookie
  if (cookieLists) {
    const cookies = cookieLists.split(';')
    cookies.forEach(function (cookieVal) {
      const vals = cookieVal.split('=')
      const cookieName = vals[0].replace(/ /, '')
      const cookieValue = vals[1]
      Object.keys(utmParams).forEach(function (key) {
        if (key === cookieName) {
          utmParams[key] = cookieValue
        }
      })
    })
  }
  Object.keys(utmParams).forEach(function (key) {
    if (utmParams[key]) {
      $(`[name="${key}"]`).val(utmParams[key])
    }
  })


  /**
   * submit前にpayloadの調整をする
   * トリガーはtype="button"にすること
   */
  $('[data-change-param]').on('click', function () {
    if ($('input[data-checkbox="grave_type"]').length) {
      $('[name="grave_type"]').val('')
      if ($('input[data-checkbox="grave_type"]:checked').length) {
        $('[name="grave_type"]').val($('input[data-checkbox="grave_type"]:checked').map(function () {
          return $(this).val()
        })
          .get()
          .join(','))
      }
    }
    if ($('input[data-checkbox="temple"]').length) {
      $('[name="temple"]').val('')
      if ($('input[data-checkbox="temple"]:checked').length) {
        $('[name="temple"]').val($('input[data-checkbox="temple"]:checked').map(function () {
          return $(this).val()
        })
          .get()
          .join(','))
      }
    }
    $('[data-request-form]').submit()
  })


  /**
   * フォームバリデーション
   */
  $('form[data-request-form]').submit(function (e) {
    let isSubmitReady = true
    let firstErrorElement = null
    const _self = $(this)
    _self.find('[data-required-error]').hide()
    _self.find('[data-kana-error]').hide()
    _self.find('[data-email-error]').hide()
    _self.find('[data-tel-error]').hide()
    _self.find('[data-validation]').map(function () {
      const inputName = $(this).data('validation-name') === undefined ? $(this).attr('name') : $(this).data('validation-name')
      const validationTypeLists = $(this).data('validation').split(',')
      const isRequired = !!validationTypeLists.find(type => type === 'required')
      const isKana = !!validationTypeLists.find(type => type === 'kana')
      const isEmail = !!validationTypeLists.find(type => type === 'email')
      const isTel = !!validationTypeLists.find(type => type === 'tel')
      const isHasBone = !!validationTypeLists.find(type => type === 'has_bone')
      if (isRequired) {
        if ($(this).data('validation-name') === undefined) {
          if (!$(this).val()) {
            isSubmitReady = false
            const errorElement = _self.find(`[data-required-error="${inputName}"]`)
            errorElement.show()
            if (!firstErrorElement) {
              firstErrorElement = $(this)
            }
          }
        } else {
          if (!$(this).find(`[name^="${inputName}"]:checked`).length) {
            isSubmitReady = false
            const errorElement = _self.find(`[data-required-error="${inputName}"]`)
            errorElement.show()
            if (!firstErrorElement) {
              firstErrorElement = errorElement.length ? errorElement : $(this)
            }
          }
        }
      }
      if (isKana) {
        if ($(this).val()) {
          if (!$(this).val().match(/^[ァ-ヶー　]+$/)) {
            isSubmitReady = false
            const errorElement = _self.find(`[data-kana-error="${inputName}"]`)
            errorElement.show()
            if (!firstErrorElement) {
              firstErrorElement = $(this)
            }
          }
        }
      }
      if (isEmail) {
        if ($(this).val()) {
          if (!$(this).val().match(/.+@.+\..+/)) {
            isSubmitReady = false
            const errorElement = _self.find(`[data-email-error="${inputName}"]`)
            errorElement.show()
            if (!firstErrorElement) {
              firstErrorElement = $(this)
            }
          }
        }
      }
      if (isTel) {
        if ($(this).val()) {
          if (!$(this).val().match(/^0\d{9,10}$/)) {
            isSubmitReady = false
            const errorElement = _self.find(`[data-tel-error="${inputName}"]`)
            errorElement.show()
            if (!firstErrorElement) {
              firstErrorElement = $(this)
            }
          }
        }
      }
      if (isHasBone) {
        const hasBoneField = _self.find('input[name="has_bone"]');
        if (hasBoneField.length > 0) {
          const hasBone = hasBoneField.filter(':checked').val();
          if (!hasBone) {
            isSubmitReady = false;
            const errorElement = _self.find(`[data-required-error="has_bone"]`)
            errorElement.show();
            if (!firstErrorElement) {
              firstErrorElement = hasBoneField.first()
            }
          }
        }
      }
    })
    if (!isSubmitReady) {
      if (firstErrorElement && firstErrorElement.length) {
        let scrollTarget = null
        if (firstErrorElement.is('[data-required-error], [data-kana-error], [data-email-error], [data-tel-error]')) {
          scrollTarget = firstErrorElement.closest('.fc-section')
        } else if (firstErrorElement.is('input[type="hidden"]')) {
          const inputName = firstErrorElement.data('validation-name') || firstErrorElement.attr('name')
          const errorElement = _self.find(`[data-required-error="${inputName}"]`)
          if (errorElement.length) {
            scrollTarget = errorElement.closest('.fc-section')
          } else {
            scrollTarget = firstErrorElement.closest('.fc-section')
          }
        } else {
          scrollTarget = firstErrorElement.closest('.fc-section').length 
            ? firstErrorElement.closest('.fc-section') 
            : firstErrorElement
        }
        
        if (scrollTarget && scrollTarget.length) {
          const offsetTop = scrollTarget.offset().top - 100
          $('html, body').animate({
            scrollTop: offsetTop
          }, 400)
          if (firstErrorElement.is('input:not([type="hidden"]), select, textarea')) {
            firstErrorElement.focus()
          }
        }
      }
      return false
    }
  })

  
  /**
   * カレンダークリック
   */
  function getDayOfWeek(dateStr) {
    const days = ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'];
    const date = new Date(dateStr);
    return days[date.getDay()];
  }

  $('[data-calendar-date-click]').on('click', function () {
    let _val = $(this).data('calendar-date-click');
    if (_val) {
      const targetForm = $(this).data('target-form');
      const dayOfWeek = getDayOfWeek(_val);
      _val = `${_val},${dayOfWeek}`;
      $(`form[data-calender-form="${targetForm}"]`)
        .find('select[name="tour_date"]')
        .val(_val);
    }
  });
})


/**
 * 動的にpath切り替え処理
 */
const calenderRequestPath = document.querySelector('[data-form-path]');

if (calenderRequestPath) {
  const url = 'https://www2.eitaikuyou.net';
  const path = calenderRequestPath.dataset.formPath;
  const requestUrl = url + path;

  const calenderRequestButton = document.querySelector('[data-change-param]');
  if (calenderRequestButton) {
    calenderRequestButton.addEventListener('click', function(event) {
      if (calenderRequestPath.checkValidity()) {
        calenderRequestPath.action = requestUrl;
      } else {
        event.preventDefault();
        calenderRequestPath.reportValidity();
      }
    });
  }
}


/**
 * フォーム送信時にsuccesslocationに値を含める
 */
document.addEventListener('DOMContentLoaded', () => {
  const fieldsToSave = ['last_name', 'first_name', 'last_kana', 'first_kana', 'email', 'tel'];
  fieldsToSave.forEach(fieldName => {
    const inputField = document.querySelector(`input[name="${fieldName}"]`);
    if (inputField) {
      inputField.addEventListener('input', (event) => {
        const fieldValue = event.target.value;
        setCookie(fieldName, fieldValue, 1);
      });
    }
  });

  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const path = window.location.pathname;
  if (path.startsWith('/document-request/complete')) {
    setFormData();
  }
  function setFormData() {
    function getCookie(name) {
      let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
      ));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    }
    const fields = ['last_name', 'first_name', 'last_kana', 'first_kana', 'email', 'tel'];
    fields.forEach(field => {
      const value = getCookie(field);
      if (value) document.querySelector(`input[name="${field}"]`).value = value;
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  function deleteCookie(name) {
    document.cookie = name + '=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT;';
  }
  function deleteFormCookies() {
    const fields = ['last_name', 'first_name', 'last_kana', 'first_kana', 'email', 'tel'];
    fields.forEach(field => {
      deleteCookie(field);
    });
  }
  const button = document.querySelector('.submit.calendar-submit[data-change-param]');
  if (button && window.location.pathname.endsWith('/document-request/complete')) {
    button.addEventListener('click', deleteFormCookies);
  }
});


/**
 * カレンダー表示
 */
$(document).ready(function() {
  let $tourDateDisplay = $("#tour_date_display");
  let $hiddenTourDate = $("#tour_date");
  let $datepickerContainer = $("#datepicker-container")[0];

  // 3ヶ月後の末日を計算する関数
  let today = new Date();
  today.setHours(0, 0, 0, 0); // 時間をリセットして、日付のみで比較できるようにする
  function getLastDateOfThreeMonthsLater() {
    let threeMonthsLater = new Date(today.getFullYear(), today.getMonth() + 4, 0);
    return threeMonthsLater;
  }

  // 日付と曜日を組み合わせたフォーマットを作成する関数（送信用）
  function createDateFormat(dateText){
    let date = new Date(dateText);
      let daysOfWeek = ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"];
      let dayOfWeek = daysOfWeek[date.getDay()];
      // 日付と曜日を組み合わせたフォーマット（送信用）
      let dateWithDayOfWeek = dateText + ',' + dayOfWeek;

      return dateWithDayOfWeek;
  }

  // 12月30日から1月4日かを判定する関数
  function isCheckHolidays(date){
    let month = date.getMonth() + 1; // 月は0から始まるので+1
    let day = date.getDate();

    return (month === 12 && day >= 30) || (month === 1 && day <= 4);
  }

  // 日付範囲のオプションを生成し、<select>に追加
  function populateDateSelect() {
    let maxDate = getLastDateOfThreeMonthsLater();
    let currentDate = new Date(today);

    while (currentDate <= maxDate) {
      if (isCheckHolidays(currentDate)) {
        currentDate.setDate(currentDate.getDate() + 1);
        continue;
      }

      let optionText = $.datepicker.formatDate('yy-mm-dd', currentDate);
      let year = currentDate.getFullYear();
      let month = currentDate.getMonth() + 1;
      let day = currentDate.getDate();
      let displayText = `${year}年${month}月${day}日`;
      let $option = $("<option>").val(optionText).text(displayText);
      $tourDateDisplay.append($option);
      currentDate.setDate(currentDate.getDate() + 1); // 次の日付に移動
    }
    $tourDateDisplay.val($.datepicker.formatDate('yy-mm-dd', today)).change();
  }

  populateDateSelect(); // ページ読み込み時に <select> に日付オプションを追加

  // 初期表示時に hidden にも値をセット
  let initialDate = $tourDateDisplay.val();
  if (initialDate) {
    $hiddenTourDate.val(createDateFormat(initialDate));
  }

  // <select> の変更イベントで hidden フィールド及びカレンダーの高さを更新
  $tourDateDisplay.on('change', function() {
    let selectedDate = $(this).val();
    let dateWithDayOfWeek = createDateFormat(selectedDate);
    $hiddenTourDate.val(dateWithDayOfWeek);

    // datepickerの選択日付を変更
    $("#datepicker-container").datepicker("setDate", selectedDate);
  });

  // 祝日データを取得してdatepickerを初期化
  $.get("https://holidays-jp.github.io/api/v1/date.json", function(holidaysData) {
    $("#datepicker-container").datepicker({
      beforeShowDay: function(date) {
        let ymd = $.datepicker.formatDate('yy-mm-dd', date);
        let isSelectable = true;
        let className = '';

        if (date < today) {
          className = 'past-date';
        } else if (isCheckHolidays(date)) {
          className = ' holidays';
          isSelectable = false;
        }
        else{
          className = 'future-date';
        }

        // 曜日や祝日条件を追加で判定
        if (date.getDay() === 0) {
          className = className + ' ' + 'day-sunday';
        } else if (date.getDay() === 6) {
          className = className + ' ' + 'day-saturday';
        } else if (holidaysData[ymd]) {
          className = className + ' ' + 'day-holiday';
        } else{
          className = className + ' ' + 'day-weekday';
        }

        return [isSelectable, className, null];
      },
      dateFormat: 'yy-mm-dd',
      minDate: 0,
      maxDate: getLastDateOfThreeMonthsLater(),
      onSelect: function(dateText, inst) {
        let dateWithDayOfWeek = createDateFormat(dateText);
        // 表示用フィールドを変更
        $tourDateDisplay.val(dateText).change();
        // 送信用hiddenフィールドに日付と曜日を設定
        $hiddenTourDate.val(dateWithDayOfWeek);
        $tourDateDisplay.next('.error-txt').hide();
      },
      monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
      monthNamesShort: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
      dayNames: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
      dayNamesMin: ["日", "月", "火", "水", "木", "金", "土"],
      showMonthAfterYear: true,
      yearSuffix: '年',
      prevText: '',
      nextText: '',
      showButtonPanel: false
    });
  });
  // カレンダー初期値設定（当日の日付を動的に処理）
  function setInitialCalendarValue() {
    const tourDateSelect = document.getElementById('tour_date_display');
    const tourDateHidden = document.getElementById('tour_date');

    // select要素に初期値がある場合、hidden inputに日付+曜日形式で値を設定
    if (tourDateSelect && tourDateSelect.value && tourDateHidden) {
      const initialValue = tourDateSelect.value;
      const date = new Date(initialValue);
      const daysOfWeek = ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"];
      const dayOfWeek = daysOfWeek[date.getDay()];
      const dateWithDayOfWeek = initialValue + ',' + dayOfWeek;

      tourDateHidden.value = dateWithDayOfWeek;
    }
  }

  // 複数のタイミングで初期値設定を試行
  setInitialCalendarValue();
  setTimeout(setInitialCalendarValue, 500);
  setTimeout(setInitialCalendarValue, 1000);
});


/**
 * 寺院検索クエリパラメーター送信
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.form-search').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // フォーム値→クエリへ
      const fd = new FormData(form);
      const params = new URLSearchParams();
      for (const [key, val] of fd.entries()) {
        const v = (val ?? '').toString().trim();
        if (v !== '') params.append(key, v);
      }

      // plan-xxx上で、値が何も無ければ /search に飛ばす
      const isPlanPage = /^\/plan-[^/]+\/?$/.test(window.location.pathname);
      const hasAnyParam = params.toString() !== '';

      const url = new URL(form.action || window.location.pathname, window.location.origin);

      if (isPlanPage && !hasAnyParam) {
        url.pathname = '/search';
        url.search = '';
      } else {
        // 既存クエリは使わず、フォーム値だけで組み直す
        url.search = params.toString();
      }

      window.location.href = url.toString();
    });
  });
});
